export default "__VITE_ASSET__d4f7e9d0__"